import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <div className="container">
        {" "}
        <header className="App-header">Dictionary</header>
        <main>
          <Dictionary defaultKeyword="sunrise" />
        </main>
        <footer>
          Coded by Jessica Cardenas and open sourced on{" "}
          <a
            href="https://github.com/JessCardenas/dictionary-react-project/tree/master"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
